import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../api/axiosConfig';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'; 

export default function InvoicePrint(){
  const { id } = useParams();
  const [data, setData] = useState(null);
  const ref = useRef();

  useEffect(()=>{
    (async ()=>{
      const r = await axios.get(`/payments/${id}`); // adjust
      setData(r.data);
    })();
  },[id]);

  const print = () => {
    window.print(); // simple: opens browser print dialog
  };

  const exportPdf = async () => {
    const canvas = await html2canvas(ref.current);
    const img = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p','mm','a4');
    const width = pdf.internal.pageSize.getWidth();
    const imgProps = pdf.getImageProperties(img);
    const height = (imgProps.height * width) / imgProps.width;
    pdf.addImage(img, 'PNG', 0, 0, width, height);
    pdf.save(`invoice_${id}.pdf`);
  };

  if (!data) return <p>Loading...</p>;

  return (
    < > 
    <div className="container" style={{marginTop:24}}>
      <div ref={ref} className="card" style={{padding:20}}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          <div>
            <h5>BetaniaHub</h5>
            <div>Invoice: {data.code}</div>
            <div>Date: {new Date(data.date).toLocaleDateString()}</div>
          </div>
          <div>
            <strong>Amount</strong>
            <div>{data.amount}</div>
          </div>
        </div>
        <hr/>
        <div>
          <h6>Member</h6>
          <div>{data.memberName}</div>
          <div>{data.memberAddress}</div>
        </div>
        <hr/>
        <div>
          <h6>Details</h6>
          <table className="striped">
            <thead><tr><th>Description</th><th>Amount</th></tr></thead>
            <tbody>
              {data.items?.map((it, idx)=>(
                <tr key={idx}>
                  <td>{it.description}</td>
                  <td>{it.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{marginTop:12}}>
        <button className="btn" onClick={print}>Print</button>
        <button className="btn" style={{marginLeft:10}} onClick={exportPdf}>Download PDF</button>
      </div>
    </div>
    </ >
  );
}
